import { render } from "./PufferIcons.vue?vue&type=template&id=dfa13446&scoped=true&ts=true"
import script from "./PufferIcons.vue?vue&type=script&lang=ts"
export * from "./PufferIcons.vue?vue&type=script&lang=ts"

import "./PufferIcons.vue?vue&type=style&index=0&id=dfa13446&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfa13446"]])

export default __exports__